import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Box } from '../../components/Box'
import { RepeatableActionTemplateTableComponent } from './components/RepeatableActionTemplateTableComponent'

export const RepeatableActionTemplate: React.FC = () => {
  return (
        <div className="content-wrapper">
            <section className="content">
                <div className="container-fluid">
                    <Row>
                        <Col md={12}>
                            <Box
                                loaded={true}
                                title={
                                    <div>
                                        <i className="fas fa-table mr-1"/>
                                        Template akcia
                                    </div>
                                }
                                isTable={true}
                            >
                                <div className="box-overflow" style={{ minHeight: '212px' }}>
                                    <RepeatableActionTemplateTableComponent/>
                                </div>
                            </Box>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
  )
}

export default RepeatableActionTemplate
